import React from "react"
import { BodyText, InlineText, SubTitle } from "../../Typography/Typography"
import SmartLink from "../../layout/SmartLink/SmartLink"

const providerProfileClickEvent = () => ({
  name: "SEO Filtered Directory - Copy link to provider clicked",
  properties: {
    "Care Type": "care_home",
    "GEO Location": "Coventry",
    "Current URL":
      "https://www.caresourcer.com/s/providers/towns/coventry/care-home/",
  },
})

export default {
  summary: (
    <BodyText marginBottom>
      Choosing a care home for a loved one can be difficult, however with 64
      care homes in Coventry, and 42 rated Good or Outstanding by the Care
      Quality Commission (CQC), there’s plenty to choose from. Here are a few of
      our top tips to help you narrow your options and find the right care home.
    </BodyText>
  ),
  content: [
    <SubTitle marginBottom bold>
      Location is key
    </SubTitle>,
    <BodyText marginBottom>
      Think about where friends and family will be visiting from, then speak to
      the care homes directly as they can advise you about the public transport
      options or local car parking. However, as transport links are good in
      Coventry and with 64 care homes to choose from, you should be able to find
      one to suit your location. There are several care homes located centrally,
      including the{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-6339771076/belvedere-park-nursing-home"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Belvedere Park Nursing Home</InlineText>
      </SmartLink>
      , which is a 10-minute walk from the railway station. Or for only for a
      short drive or bus journey there are a number of beautiful care homes with
      a little more green space available, for example the{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-126240530/godiva-lodge"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Godiva Lodge</InlineText>
      </SmartLink>{" "}
      located near Stoke Heath which has a handy bus stop directly opposite.
    </BodyText>,
    <SubTitle marginBottom bold>
      Feeling at home
    </SubTitle>,
    <BodyText marginBottom>
      Moving into a care home can feel daunting, so think about what would help
      make your loved one feel settled and at home. Many care homes in Coventry
      allow you to move in your own furniture to the room or add personal
      touches, so be sure to think about what your loved one may like to take
      with them.
    </BodyText>,
    <SubTitle marginBottom bold italic>
      Gardens and outdoor spaces
    </SubTitle>,
    <BodyText marginBottom>
      While your loved one may not be a keen gardener, do they enjoy sitting at
      their window watching the wildlife outside? Then perhaps finding a care
      home with a garden room is important. Over 50 of the care homes in
      Coventry have some outdoor garden space available, including{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-467325088/harper-fields"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Harper Fields</InlineText>
      </SmartLink>{" "}
      in Balsall which has some lovely rooms overlooking their landscaped
      gardens. For those who love to potter in the garden there are homes like
      Fairfield which encourage residents to help contribute to the garden tasks
      and help grow fresh fruit and vegetables that can go on to be used in the
      kitchens.
    </BodyText>,
    <BodyText marginBottom bold italic>
      Pets welcome
    </BodyText>,
    <BodyText marginBottom>
      Does your loved one have a pet they are worried about leaving when moving
      into a care home? We recommend looking into the 30+ pet-friendly care
      homes in Coventry. Many allow pets to move in with their owner and others,
      like{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-320756241/victoria-park-coventry"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Victoria Park</InlineText>
      </SmartLink>{" "}
      which allow pets to visit frequently.
    </BodyText>,
    <BodyText marginBottom bold italic>
      Activities and days out
    </BodyText>,
    <BodyText marginBottom>
      All care homes in Coventry work hard to make sure the residents feel at
      home and can continue with any hobbies they had prior to moving in - or
      help them discover something new! Care homes like{" "}
      <SmartLink
        to="https://www.caresourcer.com/uk/providers/cqc/1-117977045/allesley-hall"
        newTab
        clickEvent={providerProfileClickEvent()}
      >
        <InlineText brand>Allesley Hall</InlineText>
      </SmartLink>{" "}
      offer a number of activities and facilities, including an on-site hair
      salon, music therapy, bakery classes, quizzes and a variety of arts and
      crafts. Our advice is to think about what makes your loved one happy and
      be sure to ask any care homes you are interested in how they would help
      accommodate this.
    </BodyText>,
  ],
}
